export const states = [
  {
    value: '1',
    name: 'Alabama',
    shortName: 'AL'
  },
  {
    value: '2',
    name: 'Alaska',
    shortName: 'AK'
  },
  {
    value: '3',
    name: 'American Samoa',
    shortName: 'AS'
  },
  {
    value: '4',
    name: 'Arizona',
    shortName: 'AZ'
  },
  {
    value: '5',
    name: 'Arkansas',
    shortName: 'AR'
  },
  // {
  //   value: "6",
  //   name: "Armed Forces Africa",
  //   shortName: "AE"
  // },
  // {
  //   value: "7",
  //   name: "Armed Forces Americas",
  //   shortName: "AA"
  // },
  // {
  //   value: "8",
  //   name: "Armed Forces Canada",
  //   shortName: "AE"
  // },
  // {
  //   value: "9",
  //   name: "Armed Forces Europe",
  //   shortName: "AE"
  // },
  // {
  //   value: "10",
  //   name: "Armed Forces Middle East",
  //   shortName: "AE"
  // },
  // {
  //   value: "11",
  //   name: "Armed Forces Pacific",
  //   shortName: "AP"
  // },
  {
    value: '12',
    name: 'California',
    shortName: 'CA'
  },
  {
    value: '13',
    name: 'Colorado',
    shortName: 'CO'
  },
  {
    value: '14',
    name: 'Connecticut',
    shortName: 'CT'
  },
  {
    value: '15',
    name: 'Delaware',
    shortName: 'DE'
  },
  {
    value: '16',
    name: 'District of Columbia',
    shortName: 'DC'
  },
  // {
  //   value: "17",
  //   name: "Federated States Of Micronesia",
  //   shortName: "FM"
  // },
  {
    value: '18',
    name: 'Florida',
    shortName: 'FL'
  },
  {
    value: '19',
    name: 'Georgia',
    shortName: 'GA'
  },
  {
    value: '20',
    name: 'Guam',
    shortName: 'GU'
  },
  {
    value: '21',
    name: 'Hawaii',
    shortName: 'HI'
  },
  {
    value: '22',
    name: 'Idaho',
    shortName: 'ID'
  },
  {
    value: '23',
    name: 'Illinois',
    shortName: 'IL'
  },
  {
    value: '24',
    name: 'Indiana',
    shortName: 'IN'
  },
  {
    value: '25',
    name: 'Iowa',
    shortName: 'IA'
  },
  {
    value: '26',
    name: 'Kansas',
    shortName: 'KS'
  },
  {
    value: '27',
    name: 'Kentucky',
    shortName: 'KY'
  },
  {
    value: '28',
    name: 'Louisiana',
    shortName: 'LA'
  },
  {
    value: '29',
    name: 'Maine',
    shortName: 'ME'
  },
  // {
  //   value: "30",
  //   name: "Marshall Islands",
  //   shortName: "MH"
  // },
  {
    value: '31',
    name: 'Maryland',
    shortName: 'MD'
  },
  {
    value: '32',
    name: 'Massachusetts',
    shortName: 'MA'
  },
  {
    value: '33',
    name: 'Michigan',
    shortName: 'MI'
  },
  {
    value: '34',
    name: 'Minnesota',
    shortName: 'MN'
  },
  {
    value: '35',
    name: 'Mississippi',
    shortName: 'MS'
  },
  {
    value: '36',
    name: 'Missouri',
    shortName: 'MO'
  },
  {
    value: '37',
    name: 'Montana',
    shortName: 'MT'
  },
  {
    value: '38',
    name: 'Nebraska',
    shortName: 'NE'
  },
  {
    value: '39',
    name: 'Nevada',
    shortName: 'NV'
  },
  {
    value: '40',
    name: 'New Hampshire',
    shortName: 'NH'
  },
  {
    value: '41',
    name: 'New Jersey',
    shortName: 'NJ'
  },
  {
    value: '42',
    name: 'New Mexico',
    shortName: 'NM'
  },
  {
    value: '43',
    name: 'New York',
    shortName: 'NY'
  },
  {
    value: '44',
    name: 'North Carolina',
    shortName: 'NC'
  },
  {
    value: '45',
    name: 'North Dakota',
    shortName: 'ND'
  },
  // {
  //   value: "46",
  //   name: "Northern Mariana Islands",
  //   shortName: "MP"
  // },
  {
    value: '47',
    name: 'Ohio',
    shortName: 'OH'
  },
  {
    value: '48',
    name: 'Oklahoma',
    shortName: 'OK'
  },
  {
    value: '49',
    name: 'Oregon',
    shortName: 'OR'
  },
  {
    value: '50',
    name: 'Palau',
    shortName: 'PW'
  },
  {
    value: '51',
    name: 'Pennsylvania',
    shortName: 'PA'
  },
  // {
  //   value: "52",
  //   name: "Puerto Rico",
  //   shortName: "PR"
  // },
  {
    value: '53',
    name: 'Rhode Island',
    shortName: 'RI'
  },
  {
    value: '54',
    name: 'South Carolina',
    shortName: 'SC'
  },
  {
    value: '55',
    name: 'South Dakota',
    shortName: 'SD'
  },
  {
    value: '56',
    name: 'Tennessee',
    shortName: 'TN'
  },
  {
    value: '57',
    name: 'Texas',
    shortName: 'TX'
  },
  {
    value: '58',
    name: 'Utah',
    shortName: 'UT'
  },
  {
    value: '59',
    name: 'Vermont',
    shortName: 'VT'
  },
  {
    value: '60',
    name: 'Virgin Islands',
    shortName: 'VI'
  },
  {
    value: '61',
    name: 'Virginia',
    shortName: 'VA'
  },
  {
    value: '62',
    name: 'Washington',
    shortName: 'WA'
  },
  {
    value: '63',
    name: 'West Virginia',
    shortName: 'WV'
  },
  {
    value: '64',
    name: 'Wisconsin',
    shortName: 'WI'
  },
  {
    value: '65',
    name: 'Wyoming',
    shortName: 'WY'
  }
];

export const usStatesCodes = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AS': 'American Samoa',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'AE': 'Armed Forces Africa, Armed Forces Canada, Armed Forces Europe, Armed Forces Middle East',
  'AA': 'Armed Forces Americas',
  'AP': 'Armed Forces Pacific',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District of Columbia',
  'FM': 'Federated States Of Micronesia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'GU': 'Guam',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MH': 'Marshall Islands',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'MP': 'Northern Mariana Islands',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PW': 'Palau',
  'PA': 'Pennsylvania',
  'PR': 'Puerto Rico',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VI': 'Virgin Islands',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

export const countriesCodes = {
  'US': 'United States',
};
